function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import './ConfirmationCard.css';
import Card from '../Card/Card';
/**
 * See `Card` component. This is just a styling wrapper on that. This is a
 * placeholder until we get more concrete styling from UI.
 *
 * @param {Object} props React component props
 */
export default function ConfirmationCard(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, ["children"]);
  return /*#__PURE__*/React.createElement(Card, Object.assign({}, props, {
    className: "confirmation-card"
  }), children);
}